import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  fetch,
  fetchLayersRequest,
  fetchSourceResponseFormatter,
  key,
  trans,
} from "../../../lib/utils";
import store from "../../../stores/store";
import ServicePreviewComponent from "../servicePreviewComponent";

function WFS(props) {
  const [serviceUrl, setServiceUrl] = useState(null);
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [source, setSource] = useState(null);
  const [authentication, setAuthentication] = useState(false);

  const sources = useSelector((state) => store.getState().sources);

  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  const registerService = (url) => {
    let source = {
      type: "WFS",
      url: url,
      username: authentication ? username : null,
      password: authentication ? password : null,
    };
    setLoading(true);

    fetch(
      window["appConfig"]()["api"](),
      "POST",
      {},
      [fetchLayersRequest(source)],
      (resp) => {
        if (resp.data) {
          if (resp.data[0]) {
            if (resp.data[0]._response) {
              if (resp.data[0]._response._serviceId) {
                if (sources[resp.data[0]._response._serviceId]) {
                  setSource(sources[resp.data[0]._response._serviceId]);
                } else {
                  const sourcetmp = fetchSourceResponseFormatter(resp.data);

                  store.dispatch({ type: "source/add", payload: sourcetmp });

                  store.dispatch({
                    type: "layer/registeredlayertree/source/add",
                    payload: sourcetmp[resp.data[0]._response._serviceId],
                  });

                  setSource(sourcetmp[resp.data[0]._response._serviceId]);
                }
              }
            }
          }
        }
        setLoading(false);
      }
    );
  };

  return source ? (
    <ServicePreviewComponent
      source={source}
      key={key()}
    ></ServicePreviewComponent>
  ) : (
    <div className="mb-3 ">
      <label className="color-get-blue strong ">
        {trans("Type WFS service url")}
      </label>
      <div className="mt-2 input-group">
        <input
          type="text"
          className="form-control small"
          placeholder={trans("Type WFS service url")}
          value={serviceUrl}
          onChange={(e) => {
            setServiceUrl(e.target.value);
          }}
          disabled={loading}
        ></input>
        {!authentication ? (
          <button
            className="btn btn-sm btn-white border small"
            onClick={() => {
              registerService(serviceUrl);
            }}
            disabled={loading}
          >
            {!loading ? (
              trans("Register")
            ) : (
              <div className="spinner-border text-secondary" role="status">
                <span className="visually-hidden">{trans("Loading...")}</span>
              </div>
            )}
          </button>
        ) : (
          ""
        )}
      </div>

      <div class="form-check mt-2 small">
        <input
          class="form-check-input"
          type="checkbox"
          value=""
          checked={authentication}
          onChange={(e) => {
            setAuthentication(e.target.checked);
          }}
          id="authentication"
        />
        <label class="form-check-label" htmlFor="authentication">
          {trans("Requires authentication")}
        </label>
      </div>
      {authentication ? (
        <div className="mt-2 ">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder={trans("Username")}
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
            }}
            disabled={loading}
          ></input>
          <input
            type="password"
            className="form-control form-control-sm mt-2"
            placeholder={trans("Password")}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            disabled={loading}
          ></input>
          <div className="text-right mt-2">
            <button
              className="btn btn-sm btn-white border small"
              onClick={() => {
                registerService(serviceUrl);
              }}
              disabled={loading}
            >
              {!loading ? (
                trans("Register")
              ) : (
                <div className="spinner-border text-secondary" role="status">
                  <span className="visually-hidden">{trans("Loading...")}</span>
                </div>
              )}
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
export default WFS;
